<div class="table-container">
  <table class="custom-table">
    <colgroup>
      <col style="width: 16%;"> <!-- Date -->
      <col style="width: 12%;"> <!-- Check In -->
      <col style="width: 12%;"> <!-- Check Out -->
      <col style="width: 12%;"> <!-- Working Hours -->
      <col style="width: 28%;"> <!-- Status -->
      <col style="width: 20%;"> <!-- Action -->
    </colgroup>

    <tbody>

      <tr [class]="trClass">

        <td>
          {{ type.data[0].date | date: 'EEEE' }} {{ type.data[0].date | date: 'dd MMM ' }}
        </td>
        <td>
          @if (type.data.length > 0) {
          @for (obj of type.data; track $index; let i = $index) {
          @if (i > 0) {
          <span><br>
          </span>
          }
          {{ obj.check_in || '-' }}
          }
          }
          @else {
          <ng-template>-</ng-template>
          }
        </td>

        <td>
          @if (type.data.length > 0) {
          @for(obj of type.data; track $index; let i = $index){
          @if (i > 0) {
          <span><br>
          </span>
          }
          {{ obj.check_out || '-' }}
          }
          }@else {
          <ng-template>-</ng-template>
          }
        </td>
        <td>
          @if (workingHours && workingHours !== '') {
          {{ workingHours }}
          }
          @if (!workingHours || workingHours === '') {
          <ng-container>-</ng-container>}
          @if (isOverTime()) {
          <span class="overtime-design">+{{ type.data[0].overtime }}x</span>
          }

        </td>

        <td>
          @for(item of attendanceType; track $index;){
          <span class="badge" [ngClass]="item.spanClass"><img class="badge-icon" [src]="item.srcImg" alt="i" />{{
            item.title
            }}</span>
          }
          @if(isOverTime()){
          <span class="badge overtime-badge"><img class="badge-icon"
              src="../../../assets/attendance/alarm-clock-plus.svg" alt="badge" />Over Time</span>
          }

        </td>



        <td>
          <div class="button-container">
            @if(absentForLeaveBtnShow==true){
            <button type="button" class="btnLeaveAttendance" [routerLink]="['/user-leaves']">Apply Leave</button>
            }
            @if(hasTracker){
            <div class="tracker-img ">
              <img src="../../../assets/attendance/activity.svg" alt="badge" />
            </div>
            }
            @if(status === 'pending' || status === 'approved' || status === 'rejected'){
            <button class="icon-btn " type="button" (click)="btnok(id)" [ngClass]="{
              'view-btn': status === 'approved',
              'pending-btn': status === 'pending',
              'rejected-btn': status === 'rejected'
              }">
              @if(status === 'approved' || status === 'pending' || status === 'rejected'){
              <img [src]="status === 'approved' ? '../../../assets/attendance/exitV.svg'
                    : status === 'pending' ? '../../../assets/attendance/pending.svg'
                    : '../../../assets/attendance/rejected.svg'" alt="badge" />
              }
              <!-- <img src="../../../assets/attendance/exitV.svg" alt="badge" />-->
            </button>
            }

            <div class="pill-button" data-toggle="modal" data-target="#attendanceModal"
              (click)="mydata(type.data[0].user_id, type.data[0].id, type.data[0].date, type.data[0].check_in, type.data[0].check_out, type.data[0].total_hours, type.data[0].overtime, type.data[0].shift_start_time, type.data[0].shift_end_time, type.data[0].total_working_hours)">
              <span class="image-pill-btn"><img src="../../../assets/attendance/plus.svg" alt="badge" /></span>
            </div>
          </div>
        </td>
        <!--
      <i aria-hidden="true">{{ noOfRequest }}</i>
     -->

      </tr>
    </tbody>
  </table>
</div>


<!-- Modal -->
<div class="modal fade" id="attendanceModal">
  <div class="modal-dialog" style=" display: grid;
  place-items: center;
  height: 100vh; margin: 0 auto;">
    <div class="modal-content">
      <div class="modal-header  text-white" style="padding: 15px; display: flex; align-items: center;">
        <img style="width: 18px; height: 18px;" class="" src="../../../assets/attendance/attendanceModalLogo.png"
          alt="i" />
        <p class="modal-title" style="font-size: 1rem; font-weight: unset; margin-left: 10px;">
          Attendance Correction Request
        </p>
        <button type="button" class="close text-white" data-dismiss="modal">&times;</button>
      </div>
      <form id="form-link-outside-btn" name="empForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
        <div style="padding: 10px 20px; " class="bgColor-modal">
          <div class="form-group">
            <label class="lbl-modal" style="font-size: 0.9rem;">Select Request Type</label>
            <div
              style=" margin: 15px 0; padding: 0 24px; display: flex; justify-content: space-between; align-items: center; font-size: 0.9rem; ">
              <div class="custom-control custom-radio">
                <input type="radio" id="checkIn" [(ngModel)]="selectedRadio" [value]="'checkin'" name="correction"
                  class="custom-control-input">
                <label class="custom-control-label lbl-modal" for="checkIn">Punch In</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="checkOut" [(ngModel)]="selectedRadio" [value]="'checkout'" name="correction"
                  class="custom-control-input">
                <label class="custom-control-label lbl-modal" for="checkOut">Punch Out</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="overTime" [(ngModel)]="selectedRadio" [value]="'overtime'" name="correction"
                  class="custom-control-input">
                <label class="custom-control-label lbl-modal" for="overTime">Over Time</label>
              </div>
            </div>
          </div>
          @if(selectedRadio === 'checkin'){
          <div class="custom-field">
            <label for="checkin" class="lbl-modal">Punch in</label>
            <input type="time" placeholder="--:--" name="checkin" id="checkin" [(ngModel)]="_check_in" ngModel
              #checkin="ngModel" required>
            @if(checkin.invalid && (checkin.touched || checkin.dirty)){
            <div class="warningAttendance ">
              Punch in required.
            </div>
            }
          </div>
          }
          @if(selectedRadio === 'checkout'){
          <div class="custom-field">
            <label class="lbl-modal" for="">Punch Out</label>
            <input type="time" placeholder="--:--" name="checkout" id="checkout" [(ngModel)]="_check_out" ngModel
              #checkout="ngModel" required>
            @if(checkout.invalid && (checkout.touched || checkout.dirty)){
            <div class="warningAttendance">
              Punch out required.
            </div>
            }
          </div>
          }
          @if(selectedRadio === 'overtime'){

          <div class="custom-Change-overtime">
            <div class="heading-labels">
              <label class="lbl-modal" for="">Over Time</label>
            </div>
            <div class="boxes-labels">
              <label class="lbl-boxes" for="">Start Time</label>
              <label class="lbl-boxes" for="">End Time</label>
              <label class="lbl-boxes" for="">Hours</label>
            </div>
            <!-- start time -->
            <div class="boxes">
              <input type="time" placeholder="Start Time" name="overtime_start_time" id="overtime_start_time"
                [(ngModel)]="overtime_data_startTime" #overtime_start_time="ngModel" required
                (ngModelChange)="calculateWorkingHours()" />

              <input type="time" placeholder="End Time" name="overtime_end_time" id="overtime_end_time"
                [(ngModel)]="overtime_data_endTime" #overtime_end_time="ngModel" required
                (ngModelChange)="calculateWorkingHours()" />



              <!-- hours -->
              <input type="number" name="overtime" id="overtime" [(ngModel)]="_overtime" placeholder="Hours"
                #overtime="ngModel" required pattern="^[0-9]+(\.[0-9]+)?$" disabled>

            </div>
            <div class="error-message">
              @if(overtime_start_time.invalid && (overtime_start_time.touched || overtime_start_time.dirty)){
              <div class="warningAttendance ">
                Start time required.
              </div>
              }
              @if(overtime_end_time.invalid && (overtime_end_time.touched || overtime_end_time.dirty)){
              <div class="warningAttendance ">
                End time required.
              </div>
              }
              @if(overtime.invalid && (overtime.touched || overtime.dirty)){
              <div class="warningAttendance">
                Over Time Hour
              </div>
              }
            </div>

          </div>
          }
          @if(selectedRadio === 'checkin' || selectedRadio === 'checkout' || selectedRadio === 'overtime'){
          <div style="width: 465px;">
            <label class="lbl-modal" style="font-size: 14px;  margin-bottom: 5px;">Detail</label>
            <ckeditor [editor]="Editor" rows="3" ngModel (input)="trimText()" id="reason" name="reason"
              #reason="ngModel" [(ngModel)]="_reason" required></ckeditor>
            @if((reason.dirty || reason.touched)){
            <div>
              @if(_reason.trim().length < 100){ <p class="warningAttendance">
                Ensure that the entered <strong>Detail</strong> contains minimum of 100 characters.
                </p>
                }
            </div>
            }
          </div>
          }
          <div class="modal-footer1">
            <button type="button" class="btnCancelModal" data-dismiss="modal">Cancel</button>
            <button type="submit" class="subBtnModal"
              [disabled]="f.invalid || _reason.trim().length < 100 ">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>